export default '/build/905f8afe.svg'